import { USAGE_PATH } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';
import type { GlobalHomePageRoute } from '@townsquare/router/route-types';

export const usageRouteDefinition: GlobalHomePageRoute = createGlobalRoute({
	exact: true,
	name: 'usage',
	path: USAGE_PATH,
	layout: 'home',
	featureGating: {
		gates: ['townsquare_home_usage_page'],
		behavior: { type: 'enabled' },
	},
});
